"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reusables_1 = require("../../../../comps/reusables");
const react_hanger_1 = require("react-hanger");
const OsmosysResourcePage_1 = require("../../../../comps/reusables/OsmosysResourcePage");
const reactstrap_1 = require("reactstrap");
const react_2 = require("@osmosys/react");
const react_if_1 = require("react-if");
const file_saver_1 = require("file-saver");
const moment_1 = tslib_1.__importDefault(require("moment"));
const inputs_1 = require("../../../../inputs");
const hooks_1 = require("../../../../hooks");
const utils_1 = require("@osmosys/utils");
const STATUS_OPTIONS = [
    { label: 'all', value: '' },
    { label: 'subscribed', value: 'subscribed' },
    { label: 'unsubscribed', value: 'unsubscribed' },
    { label: 'cleaned', value: 'cleaned' },
    { label: 'pending', value: 'pending' },
    { label: 'transactional', value: 'transactional' },
    { label: 'archived', value: 'archived' },
];
exports.EspPullSubscribers = ({ integration, }) => {
    const { state, setState } = react_hanger_1.useSetState({
        count: 100,
        emailList: null,
        offset: 0,
        status: STATUS_OPTIONS[0],
    });
    return (react_1.default.createElement(OsmosysResourcePage_1.OsmosysResourcePageInner, null, () => {
        return (react_1.default.createElement("div", { className: "flex-full-col-centered" },
            react_1.default.createElement("div", null,
                react_1.default.createElement(ImportSubscribers, Object.assign({ integration: integration, onChange: newState => {
                        setState(Object.assign({}, newState));
                    } }, state)))));
    }));
};
// {
//   integration: Integration;
//   emailList: EmailList | null;
//   onChange: (newState: Partial<IState>) => void;
//   status: IState['status'];
// }
function ImportSubscribers({ integration, emailList, onChange, status, count, offset, }) {
    var _a, _b;
    const isValid = utils_1.isDefined((_a = integration) === null || _a === void 0 ? void 0 : _a.id) && utils_1.isDefined((_b = emailList) === null || _b === void 0 ? void 0 : _b.id);
    const { mutate, mutationResult } = hooks_1.useEspGetListSubscribers({
        count,
        emailList,
        integration,
        offset,
        status,
    });
    const members = mutationResult.data &&
        mutationResult.data.espGetListSubscribers &&
        mutationResult.data.espGetListSubscribers.members &&
        Array.isArray(mutationResult.data.espGetListSubscribers.members)
        ? mutationResult.data.espGetListSubscribers.members
        : [];
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("h3", { className: "text-center mb-3" },
            react_1.default.createElement(react_if_1.If, { condition: !mutationResult.data },
                react_1.default.createElement(react_if_1.Then, null, "Download list subscribers"),
                react_1.default.createElement(react_if_1.Else, null,
                    `${members.length} subscriber${members.length === 1 ? '' : 's'}`,
                    ' ',
                    "found"))),
        react_1.default.createElement("div", { className: "flex-full-row-centered" },
            react_1.default.createElement(react_if_1.If, { condition: !mutationResult.data },
                react_1.default.createElement(react_if_1.Then, null,
                    react_1.default.createElement("div", { style: { maxWidth: 400 }, className: "w-100" },
                        react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(reactstrap_1.FormGroup, null,
                                react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, { resource: "emailList", espId: integration.id, onChange: newList => {
                                        onChange({ emailList: newList });
                                    } })),
                            react_1.default.createElement(reactstrap_1.FormGroup, null,
                                react_1.default.createElement(reactstrap_1.Label, null, "Status"),
                                react_1.default.createElement(reusables_1.SelectBox, { value: status, options: STATUS_OPTIONS, onChange: newStatus => {
                                        onChange({
                                            status: newStatus,
                                        });
                                    } })),
                            react_1.default.createElement(reactstrap_1.FormGroup, null,
                                react_1.default.createElement(reactstrap_1.Label, null, "Count"),
                                react_1.default.createElement(reactstrap_1.Input, { type: "number", min: 1, max: 1000, value: count, onChange: e => {
                                        onChange({ count: e.target.valueAsNumber });
                                    } })),
                            react_1.default.createElement(reactstrap_1.FormGroup, null,
                                react_1.default.createElement(reactstrap_1.Label, null, "Offset"),
                                react_1.default.createElement(reactstrap_1.Input, { type: "number", min: 0, value: offset, onChange: e => {
                                        onChange({ offset: e.target.valueAsNumber });
                                    } })),
                            react_1.default.createElement(react_2.OsmosysButton, { osysName: "import", osysIcon: "arrowRight", iconPosition: "right", mutationResult: mutationResult, mutate: mutate, disabled: !isValid, childrenWhileDisabled: "Select a list to continue", renderApolloError: true, errorPrefix: "Failed to fetch subscribers" }, "Go")))),
                react_1.default.createElement(react_if_1.Else, null,
                    react_1.default.createElement("div", { className: "flex-full-col" },
                        react_1.default.createElement("div", { className: "mb-2 text-center" },
                            react_1.default.createElement(react_2.OsmosysButton, { osysName: "downloadSubscriberDataAsJson", osysIcon: "download", centered: true, className: "mb-2 mr-1", onClick: () => {
                                    const blob = new Blob([
                                        JSON.stringify(mutationResult.data &&
                                            mutationResult.data.espGetListSubscribers),
                                    ], {
                                        type: 'application/json;charset=utf-8',
                                    });
                                    file_saver_1.saveAs(blob, utils_1.osmosysSlugify(`list-${emailList.name}-subscribers-${moment_1.default().format('llll')}`).toLowerCase() + '.json');
                                } }, "Download JSON"),
                            ' ',
                            react_1.default.createElement(react_2.OsmosysButton, { osysName: "downloadSubscriberDataAsCsv", osysIcon: "download", centered: true, className: "mb-2 ml-1", onClick: () => {
                                    const blob = new Blob([
                                        members.reduce((sheet, member) => {
                                            return (sheet +
                                                '\n' +
                                                Object.entries(member)
                                                    .filter(([key]) => {
                                                    return !key.startsWith('_');
                                                })
                                                    .reduce((row, [, value]) => {
                                                    return `${JSON.stringify(value)},${row}`;
                                                }, ''));
                                        }, members[0]
                                            ? Object.entries(members[0])
                                                .filter(([key]) => {
                                                return !key.startsWith('_');
                                            })
                                                .reduce((row, [key]) => {
                                                return `${JSON.stringify(key)},${row}`;
                                            }, '')
                                            : ''),
                                    ], {
                                        type: 'application/json;charset=utf-8',
                                    });
                                    file_saver_1.saveAs(blob, utils_1.osmosysSlugify(`list-${emailList.name}-subscribers-${moment_1.default().format('llll')}`).toLowerCase() + '.csv');
                                } }, "Download CSV"))))))));
}
//# sourceMappingURL=index.js.map